import { useMutation } from 'react-query';
import {
  ConfirmPlanData,
  PaymentPlanConfirmationFrom,
  PaymentPlanConfirmationStatus,
  PaymentPlanDetailsResponse,
  confirmPaymentPlan,
} from '@frontend/api-payment-plans';
import { useTranslation } from '@frontend/i18n';
import { useAlert } from '@frontend/design-system';
import { usePaymentPlanShallowStore } from '../../providers/payment-plans-provider';

export const useActivatePlan = ({ planDetails }: { planDetails: PaymentPlanDetailsResponse | undefined }) => {
  const alerts = useAlert();
  const { t } = useTranslation('payments');
  const { setWorkflowId } = usePaymentPlanShallowStore('setWorkflowId');
  const paymentPlanId = planDetails?.id;

  const {
    mutateAsync,
    error: activatePlanError,
    isLoading: activatingPlan,
  } = useMutation({
    mutationFn: (confirmationData: ConfirmPlanData) => {
      const confirmedAt = new Date().toISOString();
      return confirmPaymentPlan({
        id: paymentPlanId!,
        confirmedAt,
        confirmationFrom: PaymentPlanConfirmationFrom.Office,
        ...confirmationData,
      });
    },
    onError: () => {
      alerts.error(t('Activating the payment plan failed. Please try again.'));
    },
    onSettled: (data) => {
      setWorkflowId(data?.data?.workflowId || '');
    },
  });

  const activatePlan = () => {
    if (paymentPlanId)
      return mutateAsync({ expireLink: true, confirmationStatus: PaymentPlanConfirmationStatus.Accept });
    else return undefined;
  };

  return { activatePlan, activatePlanError, activatingPlan };
};
